export const REALISASI_URL = 'dashboard/realisasi'
export const REALISASI_ERROR = 'REALISASI_ERROR'
export const REALISASI_LOADING = 'REALISASI_LOADING'
export const REALISASI_SUCCESS = 'REALISASI_SUCCESS'